import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect () {
    window.globalBarcode = this;
    window.addEventListener('scanning', this.scan);
    window.addEventListener('close-scanner', this.closeNativeScanner);
    let checkScannerState = setInterval(() => {
      if (window.localStorage.getItem('scannerState') === 'opened') {
        console.log('Barcode scanner should be opened');
        clearInterval(checkScannerState);
        // We are currently make it disabled to reopen scanner camera
        // this.openNativeScanner();
      }
    }, 100);
  }

  disconnect() {
    window.removeEventListener('scanning', this.scan);
  }

  scan(e) {
    var evt = event || window.event;

    if (!evt) return; // might be froala editor
    if (evt.value == 'Dead') return;
    if (evt.target.tagName == 'INPUT') return;
    if (evt.target.tagName == 'TEXTAREA') return;
    if (evt.target.tagName == 'TRIX-EDITOR') return;

    // Navigate based on barcode type
    window.globalBarcode.navigateToAppropriateUrl(e.value);
  }

  closeNativeScanner() {
    window.localStorage.setItem('scannerState', 'closed');
  }

  openNativeScanner() {
    window.NativeBridge.openBarcodeScanner();
  }

  navigateToAppropriateUrl(barcodeValue) {
    let url;

    if (barcodeValue.includes('.') && window.globalBarcode.onBarcodeScanBinUrl) {
      // If it has dots, it's a bin and we have a specific URL for bins
      url = window.globalBarcode.onBarcodeScanBinUrl;
    } else {
      // Otherwise, it's a variant
      url = window.globalBarcode.onBarcodeScanUrl;
    }

    if (url) {
      Turbo.visit(url.replace('__BARCODE__', barcodeValue));
    }
  }

  get onBarcodeScanUrl() {
    return this.context.element.dataset.onBarcodeScanUrl;
  }

  get onBarcodeScanBinUrl() {
    return this.context.element.dataset.onBarcodeScanBinUrl;
  }
}
